import component from './vi-VN/component.json';
import menu from './vi-VN/menu.json';
import pages from './vi-VN/pages.json';
import settings from './vi-VN/settings.json';
import error from './vi-VN/error.json';
import role from './vi-VN/role.json';

export default {
  'navBar.lang': 'Ngôn ngữ',
  'layout.user.link.help': 'Help',
  'layout.user.link.privacy': 'Privacy',
  'layout.user.link.terms': 'Terms',
  'app.copyright.company': 'T-connect Co., Ltd.',
  'app.copyright.produced': 'Produced by Ant Financial Experience Department',
  'app.preview.down.block': 'Download this page to your local project',
  'app.welcome.link.fetch-blocks': 'Get all block',
  'app.welcome.link.block-list': 'Quickly build standard, pages based on `block` development',
  ...menu,
  ...settings,
  ...component,
  ...pages,
  ...error,
  ...role,
};
